<template>
    <div class="header">
        <div class="header-content">
            <img class="logo" src="/assets/logo-actic-black.svg" />

            <div class="header-content-right">
                <div :class="['header-user-' + app]" class="header-user">
                    {{ authStore.user.initials }}
                </div>
                <button
                    :class="{
                        'is-active': mobileMenuOpen,
                    }"
                    class="hamburger hamburger--squeeze"
                    @click="mobileMenuOpen = !mobileMenuOpen"
                    type="button"
                >
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>

        <AppDropdown :app="app" />
        <CenterDropdown @centerSelected="centerSelected()" />
        <div
            class="header-main-menu"
            :class="{
                'is-open': mobileMenuOpen,
            }"
        >
            <div class="header-menu-first" style="display: none">
                <a
                    class="link-disabled"
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('lead_portal')"
                >
                    <span
                        :class="{
                            show: currentMenuTip == 'lead_portal',
                        }"
                        >{{ $t("header.Leadsportal") }}</span
                    >
                    <i class="material-icons-outlined color-rock">call</i>
                </a>
                <a
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('shopping_portal')"
                    ><span
                        :class="{
                            show: currentMenuTip == 'shopping_portal',
                        }"
                        >{{ $t("header.SalesPortal") }}</span
                    ><i class="material-icons-outlined color-rock pointer"
                        >add_shopping_cart</i
                    ></a
                >
            </div>
            <div class="header-menu-second">
                <div class="header-menu-languages-holder">
                    <div
                        v-on:click="languageMenuOpen = !languageMenuOpen"
                        @mouseleave="startTimer(false)"
                        @mouseenter="startTimer('translations')"
                        class="header-menu-language-switch"
                    >
                        <span
                            :class="{
                                show: currentMenuTip == 'translations',
                            }"
                            >{{ $t("header.Language") }}</span
                        >
                        <div class="current-language">
                            {{ authStore.user.language }}
                        </div>
                    </div>

                    <ul
                        class="header-menu-languages"
                        :class="languageMenuOpen ? 'active' : ''"
                    >
                        <li
                            @click="changeLanguage('no')"
                            :class="
                                authStore.user.language === 'no' ? 'active' : ''
                            "
                        >
                            NO
                        </li>
                        <li
                            @click="changeLanguage('sv')"
                            :class="
                                authStore.user.language === 'sv' ? 'active' : ''
                            "
                        >
                            SV
                        </li>
                    </ul>
                </div>

                <a
                    class="hide-on-desktop"
                    :class="[app === 'clp' ? 'link-disabled' : '']"
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('dashboard')"
                    href="/app/clp"
                    ><span
                        :class="{
                            show: currentMenuTip == 'dashboard',
                        }"
                        >{{ $t("header.clpportal") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >call</i
                    ></a
                >

                <a
                    class="hide-on-desktop"
                    :class="[app === 'sales' ? 'link-disabled' : '']"
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('dashboard')"
                    href="/app/sales"
                    ><span
                        :class="{
                            show: currentMenuTip == 'dashboard',
                        }"
                        >{{ $t("header.salesportal") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >add_shopping_cart</i
                    ></a
                >

                <a
                    v-if="app === 'clp'"
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('dashboard')"
                    href="/app/clp"
                    ><span
                        :class="{
                            show: currentMenuTip == 'dashboard',
                        }"
                        >{{ $t("header.Dashboard") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >dashboard</i
                    ></a
                >

                <a
                    v-if="app === 'sales'"
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('dashboard')"
                    href="/app/sales"
                    ><span
                        :class="{
                            show: currentMenuTip == 'dashboard',
                        }"
                        >{{ $t("header.Dashboard") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >dashboard</i
                    ></a
                >

                <a
                    v-if="
                        app === 'clp' &&
                        authStore.user.privileges.includes('edit_settings')
                    "
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('settings')"
                    href="/app/clp/settings"
                    ><span
                        :class="{
                            show: currentMenuTip == 'settings',
                        }"
                        >{{ $t("header.Settings") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >settings</i
                    ></a
                >

                <a
                    v-if="
                        app === 'sales' &&
                        authStore.user.privileges.includes('edit_settings')
                    "
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('settings')"
                    href="/app/sales/settings"
                    ><span
                        :class="{
                            show: currentMenuTip == 'settings',
                        }"
                        >{{ $t("header.Settings") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >settings</i
                    ></a
                >

                <a
                    v-if="app === 'sales'"
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('faq')"
                    @click="authStore.showFAQ = true"
                    ><span
                        :class="{
                            show: currentMenuTip == 'faq',
                        }"
                        >{{ $t("header.faq") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >quiz</i
                    ></a
                >

                <a
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('search_person')"
                    @click="authStore.showPersonSearch = true"
                    ><span
                        :class="{
                            show: currentMenuTip == 'search_person',
                        }"
                        >{{ $t("header.SearchPerson") }}</span
                    ><i class="color-rock pointer">
                        <img
                            src="/assets/icon-search-person.svg"
                            alt="search-icon"
                        />
                    </i>
                </a>

                <a
                    @mouseleave="startTimer(false)"
                    @mouseenter="startTimer('logout')"
                    @click="showLogoutModal = true"
                    ><span
                        :class="{
                            show: currentMenuTip == 'logout',
                        }"
                        >{{ $t("header.Logout") }}</span
                    ><i class="material-icons-outlined color-blue pointer"
                        >logout</i
                    ></a
                >
                <div :class="['header-user-' + app]" class="header-user">
                    {{ authStore.user.initials }}
                </div>
            </div>
        </div>
    </div>

    <div class="modal-holder" v-if="showLogoutModal">
        <div class="modal-card modal-logout">
            <h3 class="text-center">{{ $t("header.LogoutMessage") }}</h3>
            <div class="button-holder-center">
                <div
                    class="button button-transparent"
                    @click="showLogoutModal = false"
                >
                    {{ $t("header.LogoutMessageCancel") }}
                </div>
                <div class="button" @click="logout()">
                    {{ $t("header.LogoutMessageYes") }}
                </div>
            </div>
        </div>
    </div>

    <Loading :loading="loading" />
</template>

<script>
import axios from "axios";
import { mapStores } from "pinia";
import { useAuthStore } from "../stores/auth.js";
import CenterDropdown from "./CLP/CenterDropdown.vue";
import AppDropdown from "./AppDropdown.vue";
import Loading from "./Loading.vue";
import { toast } from "vue3-toastify";

export default {
    components: {
        CenterDropdown,
        AppDropdown,
        Loading,
    },
    emits: ["centerSelected"],
    props: ["app"],
    data() {
        return {
            loading: false,
            mobileMenuOpen: false,
            showLogoutModal: false,
            currentMenuTip: false,
            languageMenuOpen: false,
        };
    },
    methods: {
        changeLanguage(language) {
            if (language === this.authStore.user.language) {
                return;
            }

            this.loading = true;
            let self = this;
            axios
                .post(
                    self.authStore.api + "/user/setLanguage",
                    {
                        language: language,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    // Update localstorage and store!
                    self.authStore.user.language = language;
                    localStorage.setItem(
                        "user",
                        JSON.stringify(self.authStore.user)
                    );
                    window.location.reload();
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        centerSelected() {
            this.$emit("centerSelected");
        },
        startTimer(menuTip) {
            this.currentMenuTip = menuTip;
        },
        logout: function () {
            this.loading = true;
            let self = this;

            axios
                .post(
                    "/api/auth/logout",
                    {},
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("token");
                    self.$router.push({ path: "/app" });
                })
                .catch(() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("token");
                    self.$router.push({ path: "/app" });
                });
        },
    },
    computed: {
        ...mapStores(useAuthStore),
    },
};
</script>

<style>
.header {
    width: 100%;
    background-color: #fff;
    display: flex;
    padding: 0 14px;
    border-bottom: 1px solid #bebebe;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    flex-direction: column;
    height: 88px;
    justify-content: center;
    align-items: flex-start;

    @media (min-width: 1070px) {
        align-items: center;
        justify-content: flex-start;
        padding: 0 28px;
        height: 90px;
        flex-direction: row;
    }
}

.logo {
    width: 95px;
    height: auto;

    @media (min-width: 1070px) {
        margin-right: 38px;
    }
}

@media (max-width: 1070px) {
    .header-main-menu {
        display: flex;
        flex-direction: column-reverse;
        position: fixed;
        top: 44px;
        background: #fff;
        width: 100%;
        left: -100%;
        height: 100%;
        justify-content: flex-end;
        transition: all 0.3s ease;

        &.is-open {
            left: 0;
            transition: all 0.3s ease;
        }

        .header-menu-first,
        .header-menu-second {
            display: flex;
            flex-direction: column-reverse;

            > a {
                display: flex;
                justify-content: space-between;
                width: calc(100% - 28px);
                height: 50px;
                margin-left: 0;
                padding: 0;
                border-bottom: 1px solid #b9c5d6;
                color: #000;

                &.link-disabled {
                    color: #a1b1c8;

                    > i {
                        color: #a1b1c8;
                    }
                }
            }
        }

        .header-menu-second {
            margin-left: 0;
        }
    }

    .header-menu {
        a {
            margin-left: 20px;
        }
    }
}

@media (max-width: 1070px) {
    .header-main-menu {
        .header-user {
            display: none;
        }
    }
}

@media (min-width: 1070px) {
    .header-main-menu {
        display: flex;
        justify-content: space-between;
        flex: 1;

        a {
            position: relative;
        }

        .header-menu-language-switch > span,
        a > span {
            display: none;
            position: absolute;
            left: calc(50% - 50px);
            top: -12px;
            width: 100px;
            text-align: center;
            transition: all 0.2s ease;
            opacity: 0;
            font-size: 12px;
            color: #000;

            &.show {
                display: block;
                transition: all 0.2s ease;
                animation: showtip 1s;
                animation-fill-mode: forwards;
            }
        }
    }
}

@keyframes showtip {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.header-content {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (min-width: 1070px) {
        height: 90px;
        width: unset;
    }
}

.link-disabled {
    color: #a1b1c8;

    > i {
        color: #a1b1c8;
    }
}

.header-content-right {
    display: flex;
    align-items: center;

    @media (min-width: 1070px) {
        display: none;
    }
}

.header-user {
    font-family: "hansen-grotesque-bold";
    background-color: #f2f2f2;
    height: 28px;
    width: 28px;
    border-radius: 100%;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    letter-spacing: 1px;

    @media (min-width: 1070px) {
        width: 50px;
        height: 50px;
        font-size: 13px;
        margin-left: 20px;
        margin-right: 0;
    }

    &.header-user-sales {
        background-color: #f0957f;
        color: #fff;
    }

    &.header-user-clp {
        background-color: #617594;
        color: #fff;
    }
}

.header-mmobile-menu {
    font-size: 32px;
}

.header-menu-second {
    margin-left: auto;
}

.header-menu-first,
.header-menu-second {
    display: flex;
    align-items: center;

    a {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 30px;
        transition: all 0.2s ease;
        text-decoration: none;

        &:hover {
            i {
                transform: scale(1.1);
                transition: all 0.2s ease;
            }
        }
    }
}

/* Hamburger */

.hamburger {
    padding: 10px 10px;
    display: inline-block;
    cursor: pointer;
    transition-property: opacity, filter;
    transition-duration: 0.15s;
    transition-timing-function: linear;
    font: inherit;
    color: inherit;
    text-transform: none;
    background-color: transparent;
    border: 0;
    margin: 0;
    margin-right: -5px;
    overflow: visible;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
    background-color: #0033ff;
}

.hamburger-box {
    width: 20px;
    height: 20px;
    display: inline-block;
    position: relative;
    top: 1px;
}

.hamburger-inner {
    display: block;
    top: 50%;
    margin-top: -2px;
}
.hamburger-inner,
.hamburger-inner::before,
.hamburger-inner::after {
    width: 20px;
    height: 3px;
    background-color: #0033ff;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
}
.hamburger-inner::before,
.hamburger-inner::after {
    content: "";
    display: block;
}
.hamburger-inner::before {
    top: -8px;
}
.hamburger-inner::after {
    bottom: -8px;
}

/*
   * Squeeze
   */
.hamburger--squeeze .hamburger-inner {
    transition-duration: 0.075s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.hamburger--squeeze .hamburger-inner::before {
    transition: top 0.075s 0.12s ease, opacity 0.075s ease;
}
.hamburger--squeeze .hamburger-inner::after {
    transition: bottom 0.075s 0.12s ease,
        transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.hamburger--squeeze.is-active .hamburger-inner {
    transform: rotate(45deg);
    transition-delay: 0.12s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
.hamburger--squeeze.is-active .hamburger-inner::before {
    top: 0;
    opacity: 0;
    transition: top 0.075s ease, opacity 0.075s 0.12s ease;
}
.hamburger--squeeze.is-active .hamburger-inner::after {
    bottom: 0;
    transform: rotate(-90deg);
    transition: bottom 0.075s ease,
        transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.modal-logout {
    width: 732px;
    h3 {
        margin-bottom: 60px;
    }
}

.header-menu-languages {
    font-size: 18px;
    font-family: "hansen-grotesque-bold", sans-serif;
    display: none;
    flex-direction: column;
    padding: 10px 0;
    border-top: 1px solid #d2d9e5;

    &.active {
        display: flex;
    }

    li {
        height: 42px;
        display: flex;
        align-items: center;
        color: #0133ff;
        cursor: pointer;

        &.active {
            color: #a1b1c8;
            cursor: default;

            @media (min-width: 1070px) {
                color: #fff;
            }
        }

        @media (min-width: 1070px) {
            color: #0133ff;
        }
    }

    > span {
        cursor: pointer;
    }

    @media (min-width: 1070px) {
        position: absolute;
        top: 89px;
        background: #a1b1c8;
        width: 150px;
        padding: 20px;
        border-radius: 8px;
    }
}

.header-menu-languages-holder {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 28px);
    margin-left: 0;
    padding: 0;
    color: #000;
    flex-direction: column;
    border-bottom: 1px solid #b9c5d6;

    &.link-disabled {
        color: #a1b1c8;

        > i {
            color: #a1b1c8;
        }
    }

    @media (min-width: 1070px) {
        width: unset;
        border-bottom: 0;
    }
}

.header-menu-language-switch {
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    height: 50px;

    > .current-language {
        font-size: 18px;
        font-family: "hansen-grotesque-bold", sans-serif;
        font-weight: 700;
        cursor: pointer;
        text-transform: uppercase;
        color: #0133ff;
    }

    @media (min-width: 1070px) {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 30px;
        transition: all 0.2s ease;
        text-decoration: none;
    }
}

.header-content {
    position: relative;

    @media (min-width: 1070px) {
        &:after {
            position: absolute;
            right: 17px;
            top: 30px;
            width: 1px;
            height: 28px;
            background-color: #000;
            content: "";
            display: block;
        }
    }
}

.hide-on-desktop {
    @media (min-width: 1070px) {
        display: none !important;
    }
}
</style>
